const SPECIAL_CHARACTERS = {
  Ø: 'O',
  ø: 'o',
  Æ: 'AE',
  æ: 'ae',
  Œ: 'OE',
  œ: 'oe',
  Ð: 'D',
  ð: 'd',
  Þ: 'TH',
  þ: 'th',
  Ł: 'L',
  ł: 'l',
  ß: 'ss',
} as const;

/** Banks reject non-ASCII characters in recipient names. */
export const removeDiacritics = (value: string): string =>
  value
    .replace(
      /[ØøÆæŒœÐðÞþŁłß]/g,
      (character) =>
        SPECIAL_CHARACTERS[character as keyof typeof SPECIAL_CHARACTERS],
    )
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
